<template>
  <modal
    name="account-settings"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="580"
    height="auto"
    :clickToClose="false"
  >
    <div class="modalWrapper">
      <div v-if="viewScreen == 'profile'">
        <!-- Basic Profile Box -->
        <div class="content__box">
          <div class="content__box__body">
            <p class="txt--ss txt--semi-bold txt--off-white mb-3">
              {{ $t("PROFILE") }}
            </p>
            <div class="form-row">
              <div class="col-sm-9 order-2 order-sm-1">
                <div class="d-flex align-items-center flex-wrap">
                  <div class="d-flex align-items-center">
                    <p class="txt--xs txt--off-white">{{ $t("FIRST_NAME") }}</p>
                    <input
                      type="text"
                      class="hidden_input name__input"
                      v-model="first_name"
                    />
                  </div>
                  <div class="d-flex align-items-center">
                    <p class="txt--xs txt--off-white">{{ $t("LAST_NAME") }}</p>

                    <input
                      type="text"
                      class="hidden_input name__input"
                      v-model="last_name"
                    />
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <p class="txt--xs txt--off-white">{{ $t("COMP") }}</p>
                  <input
                    type="text"
                    class="hidden_input"
                    v-model="company"
                    :disabled="disabled"
                  />
                </div>
                <div class="d-flex align-items-center">
                  <p class="txt--xs txt--off-white">{{ $t("PHONE") }}</p>
                  <!-- <input type="text" class="hidden_input" v-model="phone" @keyup="formatUSPhone()" /> -->
                  <vue-tel-input
                    v-model="phone"
                    inputClasses="hidden_input"
                    :enabledFlags="false"
                    mode="international"
                    :inputOptions="phone_input_options"
                    :validCharactersOnly="true"
                    @validate="checkPhoneValidity"
                    @country-changed="getCountryCode"
                  ></vue-tel-input>
                </div>
                <div class="d-flex align-items-center">
                  <p class="txt--xs txt--off-white">{{ $t("EMAIL") }}</p>
                  <input type="text" class="hidden_input" v-model="email" />
                  <a
                    href="javascript:void(0);"
                    class="button-primary"
                    @click="getOTP()"
                  >
                    <p class="txt--xs txt--off-white">
                      <i class="fas fa-edit" aria-hidden="true"></i> Change
                      Email
                    </p></a
                  >
                </div>
                <p
                  class="txt--xs txt--off-white cursor-pointer mt-2"
                  @click="viewScreen = 'password'"
                >
                  {{ $t("CHNGPASS") }}
                </p>
              </div>

              <div
                class="
                  col-sm-3
                  order-1 order-sm-2
                  mb-2 mb-sm-0
                  d-flex
                  justify-sm-content-start justify-content-center
                "
              >
                <label for="profile__image" class="user__profile mb-0">
                  <div v-if="user.square_company_logo && user.square_company_logo != ''" class="profile__image">
                    <img
                      :src="user.square_company_logo"
                      class="w-100 h-100"
                      alt="Profile"
                    />
                  </div>
                  <div v-else class="profile__image">
                    <!-- <img src="@/assets/images/sp_plus.png" class="w-100" alt="Profile" /> -->
                    <i class="far fa-user"></i>
                  </div>
                  <p class="txt--xs txt--off-white cursor-pointer mt-2">
                    {{ $t("COMP_LOGO") }}
                  </p>
                  <input
                    type="file"
                    id="profile__image"
                    :disabled="disabled"
                    accept="image/*"
                    @change="getImage($event)"
                  />
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- Payment Statement Descriptor -->
        <div
          class="content__box mt-4"
        >
          <div class="content__box__body">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <p class="txt--ss txt--semi-bold txt--off-white"> Payment Statement Descriptor
              </p>
            </div>
            <div class="">
              <div class="">
                <div class="d-flex justify-content-between" v-if="payment_statement_descriptor!=''">
                  <p class="txt--xs">{{payment_statement_descriptor!='' ? payment_statement_descriptor : ''}} </p>
                  <a href="javascript:void(0);" class="txt--xs txt--off-white" @click="viewScreen='statementDescriptor'"><i class="fas fa-edit"></i></a>
                </div>
                <div v-else class="d-flex align-items-center">
                  <a href="javascript:void(0);" class="txt--xs txt--off-white" @click="viewScreen='statementDescriptor'"><i class="fas fa-plus mr-2"></i>Add Payment Statement Descriptor</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Bank Account Information (Update)-->
        <div
          class="content__box mt-4"
          v-if="Object.keys(account_data).length > 0 && disabled == false"
        >
          <div class="content__box__body">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <p class="txt--ss txt--semi-bold txt--off-white">Bank Account
                 <span class="txt--xs txt badge badge-pill ml-2 badge-success">{{ stripe_verified }}</span>
              </p>
             
              <p
                class="txt--xs txt--semi-bold txt--off-white cursor-pointer"
                @click="viewScreen = 'bankDetails'"
                v-if="user.external_account_type=='CUSTOM'"
              >
                Update
              </p>
            </div>
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center pt-1">
                  <p class="txt--xs txt--off-white">Name</p>
                  <p class="txt--xs txt--semi-bold ml-2">
                    {{ account_data.bank_details ? account_data.bank_details.bank_name : "" }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center pt-1">
                  <p class="txt--xs txt--off-white">Account Number</p>
                  <p class="txt--xs txt--semi-bold ml-2">
                    **** **** **** {{ account_data.bank_details.last4 }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Bank Account Information (Add) -->
        <div class="content__box mt-4" v-else-if="disabled == false && user.external_account_type!='STANDARD'">
          <div class="content__box__body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <p
                class="
                  txt--ss txt--semi-bold txt--off-white
                  d-flex
                  justify-content-center
                "
              >
                Bank Account
              </p>
              <p
                class="txt--xs txt--semi-bold txt--off-white cursor-pointer"
                @click="viewScreen = 'bankDetails'"
              >
                Add
              </p>
            </div>
          </div>
        </div>
        <!-- Create Standard Custom Account -->
        <div class="content__box mt-4" v-if="user.external_account_type == 'STANDARD' && stripe_verified!='verified'">
          <div class="content__box__body">
            <div class="d-flex justify-content-center align-items-center">
              <p class="txt--ss txt--off-white" v-if="external_account_id==''">You need to create a stripe handled standard connected account in order for you to receive sessions and subscriptions!</p>
              <p class="txt--ss txt--off-white" v-else-if="external_account_id!='' && stripe_verified=='unverified'">You need to verify your stripe handled standard connected account in order for you to receive sessions and subscriptions!</p>
              <p class="txt--ss txt--off-white" v-else-if="external_account_id!='' && stripe_verified=='pending'">Your stripe handled standard connected account is under verification!</p>
              <ButtonWithSpinner
                class="button button--primary button--sm mr-3"
                type="submit"
                v-if="external_account_id==''"
                @click="createStandardAccount"
                :disabled="button.disabled"
                :loading="button.loading"
                :success="button.success"
              >
                Create
              </ButtonWithSpinner >
            </div>
          </div>
        </div>
        <!-- Stripe Verification Link For CUSTOM and EXPRESS type Connected Account -->
        <div
          v-if="
            (Object.keys(account_data).length > 0 || user.external_account_type=='STANDARD') &&
            stripe_verified === 'unverified'
          "
          class="d-flex justify-content-center mt-1"
        >
          <p class="txt--red txt--ss">
            ***Please
            <a v-if="verification_url != ''" :href="verification_url">verify</a>
            <a
              v-else
              href="javascript:void(0);"
              @click="getAccountVerificationLink"
              >verify</a
            >
            your account in order to receive sessions in your property***
          </p>
        </div>
        <!-- Stripe Processing Verification For CUSTOM and EXPRESS type Connected Account -->
        <div
          class="d-flex justify-content-center mt-1"
          v-else-if="
            (Object.keys(account_data).length > 0 || user.external_account_type=='STANDARD') &&
            stripe_verified === 'pending'
          "
        >
          <p class="txt--ss txt--primary">
            ***Your account is under verification***
          </p>
        </div>
        <!-- Generate Stripe Login Link -->
        <div class="content__box mt-4" v-if="external_account_id!='' && user.external_account_type=='EXPRESS' && stripe_verified=='verified'">
          <div class="content__box__body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <p
                class="
                  txt--ss txt--semi-bold txt--off-white
                  d-flex
                  justify-content-center
                "
              >
                Get Stripe Login Link
              </p>
              <p
                class="txt--xs txt--semi-bold txt--off-white cursor-pointer"
                v-if="!generating_stripe_login_link"
                @click="generateStripeLoginLink"
              >
                Generate
              </p>
            </div>
            <div class="d-flex justify-content-center" v-if="stripe_login_link!=''">
              <a :href="stripe_login_link" target="_blank" class="txt--ss">{{stripe_login_link}}</a>
            </div>
          </div>
        </div>
        <!-- Basic Info Save Button -->
        <div class="d-flex justify-content-center flex-wrap mt-4">
          <button
            type="button"
            class="button button--primary button--sm mr-3"
            @click="updateUserDetails()"
          >
            Save
          </button>
          <button
            type="button"
            class="button button--outline button--sm"
            @click="closeModal"
          >
            Cancel
          </button>
        </div>
      </div>
      <!-- Change Password Section -->
      <div v-if="viewScreen == 'password'">
        <div class="content__box">
          <div class="content__box__body">
            <p class="txt--ss txt--semi-bold txt--off-white mb-3">
              Change Password
            </p>

            <div class="form__group mb-3">
              <label class="txt--xs txt--off-white">Current Password</label>
              <div class="password-field">
                <input
                  type="password"
                  class="textInputField"
                  placeholder="Enter current password"
                  v-model="old_password"
                />
                <button
                  class="passwordToggleBtn"
                  data-password="hidden"
                  @click="togglePassword($event)"
                >
                  <svg
                    width="18"
                    height="12"
                    viewBox="0 0 18 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="show__pass"
                  >
                    <path
                      d="M6.7009 6.12565C6.53454 5.95812 6.2641 5.95812 6.09774 6.12565C5.93096 6.29275 5.93096 6.56439 6.09774 6.7315C6.2641 6.89903 6.53454 6.89903 6.7009 6.7315C6.86769 6.56439 6.86769 6.29275 6.7009 6.12565Z"
                      fill="#767B82"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.67969 7.71408C7.67969 7.24145 8.06249 6.85693 8.53302 6.85693C9.00355 6.85693 9.38635 7.24145 9.38635 7.71408C9.38635 8.1867 9.00355 8.57122 8.53302 8.57122C8.06249 8.57122 7.67969 8.1867 7.67969 7.71408ZM8.24858 7.71408C8.24858 7.87162 8.37618 7.99979 8.53302 7.99979C8.68986 7.99979 8.81747 7.87162 8.81747 7.71408C8.81747 7.55653 8.68986 7.42836 8.53302 7.42836C8.37618 7.42836 8.24858 7.55653 8.24858 7.71408Z"
                      fill="#767B82"
                    />
                    <path
                      d="M8.53266 5.14307C8.17496 5.14307 7.82907 5.21568 7.50469 5.35891C7.3429 5.43036 7.26939 5.62 7.3405 5.78252C7.4116 5.94503 7.60043 6.01883 7.76222 5.94744C8.00494 5.84028 8.26418 5.78592 8.53266 5.78592C9.59134 5.78592 10.4527 6.65108 10.4527 7.71449C10.4527 8.77791 9.59134 9.64307 8.53266 9.64307C7.47397 9.64307 6.61266 8.77791 6.61266 7.71449C6.61266 7.7035 6.61262 7.69277 6.61288 7.68177C6.61698 7.50431 6.47707 7.3571 6.3004 7.35298C6.12344 7.34855 5.97717 7.48937 5.97307 7.66686C5.97269 7.68287 5.97266 7.69849 5.97266 7.71449C5.97266 9.13238 7.12107 10.2859 8.53266 10.2859C9.94424 10.2859 11.0927 9.13238 11.0927 7.71449C11.0927 6.29661 9.94424 5.14307 8.53266 5.14307Z"
                      fill="#767B82"
                    />
                    <path
                      d="M8.95987 0C8.72422 0 8.5332 0.143904 8.5332 0.321429V2.25C8.5332 2.42752 8.72422 2.57143 8.95987 2.57143C9.19552 2.57143 9.38654 2.42752 9.38654 2.25V0.321429C9.38654 0.143904 9.19552 0 8.95987 0Z"
                      fill="#767B82"
                    />
                    <path
                      d="M5.04065 2.95978L3.88083 1.79479C3.77406 1.68754 3.60093 1.68754 3.49414 1.79479C3.38737 1.90203 3.38737 2.07593 3.49414 2.1832L4.65396 3.3482C4.76073 3.45544 4.93388 3.45547 5.04065 3.3482C5.14742 3.24095 5.14742 3.06706 5.04065 2.95978Z"
                      fill="#767B82"
                    />
                    <path
                      d="M13.5739 1.79479C13.4671 1.68754 13.294 1.68754 13.1872 1.79479L12.0273 2.95978C11.9206 3.06703 11.9206 3.24093 12.0273 3.3482C12.1341 3.45544 12.3072 3.45547 12.414 3.3482L13.5739 2.1832C13.6806 2.07596 13.6806 1.90206 13.5739 1.79479Z"
                      fill="#767B82"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.53333 3.42871C11.7215 3.42871 14.8657 5.39984 16.9832 7.7708C17.105 7.90725 17.092 8.1156 16.954 8.23613C16.8156 8.35702 16.605 8.3433 16.4835 8.20728C16.4125 8.12777 16.3397 8.04851 16.266 7.96972C14.6188 10.4312 11.6329 12.0001 8.53333 12.0001C5.43377 12.0001 2.44783 10.4312 0.800664 7.96972C0.726964 8.04848 0.654197 8.12773 0.583164 8.20728C0.461331 8.34373 0.250664 8.35666 0.112664 8.23613C-0.025303 8.1156 -0.0383696 7.90728 0.0834971 7.7708C2.2006 5.40034 5.3447 3.42871 8.53333 3.42871ZM1.27703 7.48432C2.7843 9.8349 5.60283 11.3408 8.53333 11.3408C11.4638 11.3408 14.2824 9.8349 15.7896 7.48428C14.602 6.3334 11.858 4.08805 8.53333 4.08805C5.2087 4.08805 2.46463 6.3334 1.27703 7.48432Z"
                      fill="#767B82"
                    />
                  </svg>

                  <svg
                    class="hide__pass"
                    width="18"
                    height="7"
                    viewBox="0 0 18 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.9491 2.46709L16.9331 2.46211C16.4245 2.30303 15.9868 1.98437 15.6781 1.55386C15.9951 1.29643 16.3007 1.02103 16.5926 0.726816C16.7576 0.560547 16.7576 0.290982 16.5926 0.12467C16.4277 -0.0415567 16.1602 -0.0415567 15.9952 0.12467C14.3384 1.79447 12.2221 2.83279 9.93366 3.12016C9.91832 3.12122 9.9032 3.12301 9.88833 3.12565C9.47197 3.1761 9.05008 3.20195 8.62421 3.20199C8.624 3.20199 8.62379 3.20195 8.62354 3.20195C8.62328 3.20195 8.62311 3.20199 8.62286 3.20199C8.197 3.20199 7.7751 3.1761 7.3587 3.12565C7.34383 3.12297 7.32875 3.12118 7.31337 3.12016C5.02495 2.83279 2.90864 1.79447 1.25183 0.12467C1.08685 -0.0415141 0.819371 -0.0415567 0.654391 0.12467C0.489411 0.290939 0.489411 0.560504 0.654391 0.726816C0.946328 1.02103 1.25195 1.29647 1.56894 1.55386C1.26028 1.98437 0.822624 2.30307 0.314461 2.46193L0.297899 2.46709C0.0749547 2.53649 -0.0499315 2.77484 0.0189334 2.99953C0.0749547 3.18236 0.242047 3.29975 0.422405 3.29975C0.463724 3.29975 0.505719 3.29358 0.547207 3.28068L0.564318 3.27536C1.24485 3.06251 1.83101 2.63719 2.24606 2.06285C2.39055 2.1632 2.53702 2.26003 2.68552 2.35315C2.47923 3.00554 1.99637 3.5327 1.35593 3.78877L1.22512 3.84101C1.00822 3.9277 0.902178 4.17517 0.988154 4.39372C1.05389 4.56084 1.21283 4.66261 1.38094 4.66261C1.43278 4.66261 1.48546 4.6529 1.53658 4.6325L1.66751 4.58018C2.48928 4.2516 3.12263 3.59772 3.43218 2.78196C3.59446 2.86703 3.75859 2.94797 3.92459 3.02478C3.87617 3.75488 3.45732 4.40658 2.80707 4.74849L2.78189 4.76173C2.575 4.87043 2.49473 5.12757 2.60255 5.33607C2.67788 5.48173 2.82507 5.5651 2.97746 5.5651C3.04324 5.5651 3.11004 5.54956 3.1724 5.51678L3.1977 5.50349C4.02729 5.06727 4.58843 4.27216 4.7355 3.36175C4.91468 3.42796 5.0955 3.4897 5.27806 3.54662C5.25389 4.22196 4.99406 4.86383 4.53917 5.36396C4.3815 5.5373 4.39312 5.80657 4.56516 5.96551C4.64627 6.04045 4.74851 6.07741 4.85046 6.07741C4.96478 6.07741 5.07873 6.03091 5.162 5.93933C5.70945 5.33739 6.03975 4.57749 6.1106 3.7714C6.3534 3.82683 6.59866 3.8738 6.84589 3.91301C6.79114 4.56706 6.59198 5.2031 6.26067 5.77135L6.2038 5.8689C6.08563 6.07166 6.15293 6.33254 6.35412 6.45167C6.42134 6.49144 6.49498 6.51039 6.56773 6.51039C6.71264 6.51039 6.85367 6.43515 6.93238 6.30014L6.9892 6.20267C7.37966 5.533 7.61642 4.78438 7.68528 4.01405C7.85647 4.02819 8.02842 4.03836 8.20105 4.04475V6.57426C8.20105 6.80938 8.3902 7 8.62349 7C8.85679 7 9.04594 6.80933 9.04594 6.57426V4.04475C9.2186 4.03836 9.39051 4.02819 9.5617 4.01405C9.63057 4.7843 9.86729 5.533 10.2577 6.20259L10.3146 6.30014C10.3933 6.4352 10.5344 6.51039 10.6793 6.51039C10.752 6.51039 10.8256 6.49144 10.8929 6.45167C11.0941 6.33254 11.1613 6.07166 11.0432 5.8689L10.9863 5.77127C10.655 5.2031 10.4558 4.56698 10.4011 3.91301C10.6483 3.87375 10.8936 3.82683 11.1364 3.7714C11.2072 4.57745 11.5375 5.33739 12.085 5.93933C12.1683 6.03091 12.2822 6.07741 12.3965 6.07741C12.4985 6.07741 12.6008 6.04041 12.6818 5.96551C12.8538 5.80661 12.8655 5.5373 12.7078 5.36396C12.253 4.86383 11.9931 4.22188 11.9689 3.54662C12.1515 3.4897 12.3323 3.428 12.5115 3.36175C12.6586 4.2722 13.2197 5.06732 14.0494 5.50353L14.0746 5.51678C14.137 5.54956 14.2037 5.5651 14.2695 5.5651C14.422 5.5651 14.5691 5.48169 14.6444 5.33607C14.7523 5.12757 14.672 4.87039 14.4651 4.76173L14.44 4.74853C13.7897 4.40663 13.3708 3.75488 13.3224 3.02478C13.4884 2.94797 13.6526 2.86703 13.8148 2.78196C14.1243 3.59772 14.7577 4.2516 15.5795 4.58022L15.7104 4.63255C15.7615 4.65294 15.8142 4.66265 15.8661 4.66265C16.0342 4.66265 16.1931 4.56076 16.2588 4.39377C16.3449 4.17517 16.2388 3.92774 16.0219 3.84105L15.8911 3.78877C15.2506 3.53266 14.7677 3.00549 14.5614 2.3531C14.7099 2.25998 14.8564 2.16316 15.0009 2.0628C15.4159 2.63719 16.0021 3.06251 16.6832 3.27548L16.6997 3.28064C16.7413 3.29358 16.7833 3.29971 16.8245 3.29971C17.0049 3.29971 17.172 3.18228 17.228 2.99949C17.297 2.77484 17.1721 2.53649 16.9491 2.46709Z"
                      fill="#767B82"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div class="form__group mb-3">
              <label class="txt--xs txt--off-white">New Password</label>
              <div class="password-field">
                <input
                  type="password"
                  class="textInputField"
                  placeholder="Enter new password"
                  v-model="new_password"
                />
                <button
                  class="passwordToggleBtn"
                  data-password="hidden"
                  @click="togglePassword($event)"
                >
                  <svg
                    width="18"
                    height="12"
                    viewBox="0 0 18 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="show__pass"
                  >
                    <path
                      d="M6.7009 6.12565C6.53454 5.95812 6.2641 5.95812 6.09774 6.12565C5.93096 6.29275 5.93096 6.56439 6.09774 6.7315C6.2641 6.89903 6.53454 6.89903 6.7009 6.7315C6.86769 6.56439 6.86769 6.29275 6.7009 6.12565Z"
                      fill="#767B82"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.67969 7.71408C7.67969 7.24145 8.06249 6.85693 8.53302 6.85693C9.00355 6.85693 9.38635 7.24145 9.38635 7.71408C9.38635 8.1867 9.00355 8.57122 8.53302 8.57122C8.06249 8.57122 7.67969 8.1867 7.67969 7.71408ZM8.24858 7.71408C8.24858 7.87162 8.37618 7.99979 8.53302 7.99979C8.68986 7.99979 8.81747 7.87162 8.81747 7.71408C8.81747 7.55653 8.68986 7.42836 8.53302 7.42836C8.37618 7.42836 8.24858 7.55653 8.24858 7.71408Z"
                      fill="#767B82"
                    />
                    <path
                      d="M8.53266 5.14307C8.17496 5.14307 7.82907 5.21568 7.50469 5.35891C7.3429 5.43036 7.26939 5.62 7.3405 5.78252C7.4116 5.94503 7.60043 6.01883 7.76222 5.94744C8.00494 5.84028 8.26418 5.78592 8.53266 5.78592C9.59134 5.78592 10.4527 6.65108 10.4527 7.71449C10.4527 8.77791 9.59134 9.64307 8.53266 9.64307C7.47397 9.64307 6.61266 8.77791 6.61266 7.71449C6.61266 7.7035 6.61262 7.69277 6.61288 7.68177C6.61698 7.50431 6.47707 7.3571 6.3004 7.35298C6.12344 7.34855 5.97717 7.48937 5.97307 7.66686C5.97269 7.68287 5.97266 7.69849 5.97266 7.71449C5.97266 9.13238 7.12107 10.2859 8.53266 10.2859C9.94424 10.2859 11.0927 9.13238 11.0927 7.71449C11.0927 6.29661 9.94424 5.14307 8.53266 5.14307Z"
                      fill="#767B82"
                    />
                    <path
                      d="M8.95987 0C8.72422 0 8.5332 0.143904 8.5332 0.321429V2.25C8.5332 2.42752 8.72422 2.57143 8.95987 2.57143C9.19552 2.57143 9.38654 2.42752 9.38654 2.25V0.321429C9.38654 0.143904 9.19552 0 8.95987 0Z"
                      fill="#767B82"
                    />
                    <path
                      d="M5.04065 2.95978L3.88083 1.79479C3.77406 1.68754 3.60093 1.68754 3.49414 1.79479C3.38737 1.90203 3.38737 2.07593 3.49414 2.1832L4.65396 3.3482C4.76073 3.45544 4.93388 3.45547 5.04065 3.3482C5.14742 3.24095 5.14742 3.06706 5.04065 2.95978Z"
                      fill="#767B82"
                    />
                    <path
                      d="M13.5739 1.79479C13.4671 1.68754 13.294 1.68754 13.1872 1.79479L12.0273 2.95978C11.9206 3.06703 11.9206 3.24093 12.0273 3.3482C12.1341 3.45544 12.3072 3.45547 12.414 3.3482L13.5739 2.1832C13.6806 2.07596 13.6806 1.90206 13.5739 1.79479Z"
                      fill="#767B82"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.53333 3.42871C11.7215 3.42871 14.8657 5.39984 16.9832 7.7708C17.105 7.90725 17.092 8.1156 16.954 8.23613C16.8156 8.35702 16.605 8.3433 16.4835 8.20728C16.4125 8.12777 16.3397 8.04851 16.266 7.96972C14.6188 10.4312 11.6329 12.0001 8.53333 12.0001C5.43377 12.0001 2.44783 10.4312 0.800664 7.96972C0.726964 8.04848 0.654197 8.12773 0.583164 8.20728C0.461331 8.34373 0.250664 8.35666 0.112664 8.23613C-0.025303 8.1156 -0.0383696 7.90728 0.0834971 7.7708C2.2006 5.40034 5.3447 3.42871 8.53333 3.42871ZM1.27703 7.48432C2.7843 9.8349 5.60283 11.3408 8.53333 11.3408C11.4638 11.3408 14.2824 9.8349 15.7896 7.48428C14.602 6.3334 11.858 4.08805 8.53333 4.08805C5.2087 4.08805 2.46463 6.3334 1.27703 7.48432Z"
                      fill="#767B82"
                    />
                  </svg>

                  <svg
                    class="hide__pass"
                    width="18"
                    height="7"
                    viewBox="0 0 18 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.9491 2.46709L16.9331 2.46211C16.4245 2.30303 15.9868 1.98437 15.6781 1.55386C15.9951 1.29643 16.3007 1.02103 16.5926 0.726816C16.7576 0.560547 16.7576 0.290982 16.5926 0.12467C16.4277 -0.0415567 16.1602 -0.0415567 15.9952 0.12467C14.3384 1.79447 12.2221 2.83279 9.93366 3.12016C9.91832 3.12122 9.9032 3.12301 9.88833 3.12565C9.47197 3.1761 9.05008 3.20195 8.62421 3.20199C8.624 3.20199 8.62379 3.20195 8.62354 3.20195C8.62328 3.20195 8.62311 3.20199 8.62286 3.20199C8.197 3.20199 7.7751 3.1761 7.3587 3.12565C7.34383 3.12297 7.32875 3.12118 7.31337 3.12016C5.02495 2.83279 2.90864 1.79447 1.25183 0.12467C1.08685 -0.0415141 0.819371 -0.0415567 0.654391 0.12467C0.489411 0.290939 0.489411 0.560504 0.654391 0.726816C0.946328 1.02103 1.25195 1.29647 1.56894 1.55386C1.26028 1.98437 0.822624 2.30307 0.314461 2.46193L0.297899 2.46709C0.0749547 2.53649 -0.0499315 2.77484 0.0189334 2.99953C0.0749547 3.18236 0.242047 3.29975 0.422405 3.29975C0.463724 3.29975 0.505719 3.29358 0.547207 3.28068L0.564318 3.27536C1.24485 3.06251 1.83101 2.63719 2.24606 2.06285C2.39055 2.1632 2.53702 2.26003 2.68552 2.35315C2.47923 3.00554 1.99637 3.5327 1.35593 3.78877L1.22512 3.84101C1.00822 3.9277 0.902178 4.17517 0.988154 4.39372C1.05389 4.56084 1.21283 4.66261 1.38094 4.66261C1.43278 4.66261 1.48546 4.6529 1.53658 4.6325L1.66751 4.58018C2.48928 4.2516 3.12263 3.59772 3.43218 2.78196C3.59446 2.86703 3.75859 2.94797 3.92459 3.02478C3.87617 3.75488 3.45732 4.40658 2.80707 4.74849L2.78189 4.76173C2.575 4.87043 2.49473 5.12757 2.60255 5.33607C2.67788 5.48173 2.82507 5.5651 2.97746 5.5651C3.04324 5.5651 3.11004 5.54956 3.1724 5.51678L3.1977 5.50349C4.02729 5.06727 4.58843 4.27216 4.7355 3.36175C4.91468 3.42796 5.0955 3.4897 5.27806 3.54662C5.25389 4.22196 4.99406 4.86383 4.53917 5.36396C4.3815 5.5373 4.39312 5.80657 4.56516 5.96551C4.64627 6.04045 4.74851 6.07741 4.85046 6.07741C4.96478 6.07741 5.07873 6.03091 5.162 5.93933C5.70945 5.33739 6.03975 4.57749 6.1106 3.7714C6.3534 3.82683 6.59866 3.8738 6.84589 3.91301C6.79114 4.56706 6.59198 5.2031 6.26067 5.77135L6.2038 5.8689C6.08563 6.07166 6.15293 6.33254 6.35412 6.45167C6.42134 6.49144 6.49498 6.51039 6.56773 6.51039C6.71264 6.51039 6.85367 6.43515 6.93238 6.30014L6.9892 6.20267C7.37966 5.533 7.61642 4.78438 7.68528 4.01405C7.85647 4.02819 8.02842 4.03836 8.20105 4.04475V6.57426C8.20105 6.80938 8.3902 7 8.62349 7C8.85679 7 9.04594 6.80933 9.04594 6.57426V4.04475C9.2186 4.03836 9.39051 4.02819 9.5617 4.01405C9.63057 4.7843 9.86729 5.533 10.2577 6.20259L10.3146 6.30014C10.3933 6.4352 10.5344 6.51039 10.6793 6.51039C10.752 6.51039 10.8256 6.49144 10.8929 6.45167C11.0941 6.33254 11.1613 6.07166 11.0432 5.8689L10.9863 5.77127C10.655 5.2031 10.4558 4.56698 10.4011 3.91301C10.6483 3.87375 10.8936 3.82683 11.1364 3.7714C11.2072 4.57745 11.5375 5.33739 12.085 5.93933C12.1683 6.03091 12.2822 6.07741 12.3965 6.07741C12.4985 6.07741 12.6008 6.04041 12.6818 5.96551C12.8538 5.80661 12.8655 5.5373 12.7078 5.36396C12.253 4.86383 11.9931 4.22188 11.9689 3.54662C12.1515 3.4897 12.3323 3.428 12.5115 3.36175C12.6586 4.2722 13.2197 5.06732 14.0494 5.50353L14.0746 5.51678C14.137 5.54956 14.2037 5.5651 14.2695 5.5651C14.422 5.5651 14.5691 5.48169 14.6444 5.33607C14.7523 5.12757 14.672 4.87039 14.4651 4.76173L14.44 4.74853C13.7897 4.40663 13.3708 3.75488 13.3224 3.02478C13.4884 2.94797 13.6526 2.86703 13.8148 2.78196C14.1243 3.59772 14.7577 4.2516 15.5795 4.58022L15.7104 4.63255C15.7615 4.65294 15.8142 4.66265 15.8661 4.66265C16.0342 4.66265 16.1931 4.56076 16.2588 4.39377C16.3449 4.17517 16.2388 3.92774 16.0219 3.84105L15.8911 3.78877C15.2506 3.53266 14.7677 3.00549 14.5614 2.3531C14.7099 2.25998 14.8564 2.16316 15.0009 2.0628C15.4159 2.63719 16.0021 3.06251 16.6832 3.27548L16.6997 3.28064C16.7413 3.29358 16.7833 3.29971 16.8245 3.29971C17.0049 3.29971 17.172 3.18228 17.228 2.99949C17.297 2.77484 17.1721 2.53649 16.9491 2.46709Z"
                      fill="#767B82"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div class="form__group mb-3">
              <label class="txt--xs txt--off-white">Confirm New Password</label>
              <div class="password-field">
                <input
                  type="password"
                  class="textInputField"
                  placeholder="Re-enter new password"
                  v-model="confirm_password"
                />
                <button
                  class="passwordToggleBtn"
                  data-password="hidden"
                  @click="togglePassword($event)"
                >
                  <svg
                    width="18"
                    height="12"
                    viewBox="0 0 18 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="show__pass"
                  >
                    <path
                      d="M6.7009 6.12565C6.53454 5.95812 6.2641 5.95812 6.09774 6.12565C5.93096 6.29275 5.93096 6.56439 6.09774 6.7315C6.2641 6.89903 6.53454 6.89903 6.7009 6.7315C6.86769 6.56439 6.86769 6.29275 6.7009 6.12565Z"
                      fill="#767B82"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.67969 7.71408C7.67969 7.24145 8.06249 6.85693 8.53302 6.85693C9.00355 6.85693 9.38635 7.24145 9.38635 7.71408C9.38635 8.1867 9.00355 8.57122 8.53302 8.57122C8.06249 8.57122 7.67969 8.1867 7.67969 7.71408ZM8.24858 7.71408C8.24858 7.87162 8.37618 7.99979 8.53302 7.99979C8.68986 7.99979 8.81747 7.87162 8.81747 7.71408C8.81747 7.55653 8.68986 7.42836 8.53302 7.42836C8.37618 7.42836 8.24858 7.55653 8.24858 7.71408Z"
                      fill="#767B82"
                    />
                    <path
                      d="M8.53266 5.14307C8.17496 5.14307 7.82907 5.21568 7.50469 5.35891C7.3429 5.43036 7.26939 5.62 7.3405 5.78252C7.4116 5.94503 7.60043 6.01883 7.76222 5.94744C8.00494 5.84028 8.26418 5.78592 8.53266 5.78592C9.59134 5.78592 10.4527 6.65108 10.4527 7.71449C10.4527 8.77791 9.59134 9.64307 8.53266 9.64307C7.47397 9.64307 6.61266 8.77791 6.61266 7.71449C6.61266 7.7035 6.61262 7.69277 6.61288 7.68177C6.61698 7.50431 6.47707 7.3571 6.3004 7.35298C6.12344 7.34855 5.97717 7.48937 5.97307 7.66686C5.97269 7.68287 5.97266 7.69849 5.97266 7.71449C5.97266 9.13238 7.12107 10.2859 8.53266 10.2859C9.94424 10.2859 11.0927 9.13238 11.0927 7.71449C11.0927 6.29661 9.94424 5.14307 8.53266 5.14307Z"
                      fill="#767B82"
                    />
                    <path
                      d="M8.95987 0C8.72422 0 8.5332 0.143904 8.5332 0.321429V2.25C8.5332 2.42752 8.72422 2.57143 8.95987 2.57143C9.19552 2.57143 9.38654 2.42752 9.38654 2.25V0.321429C9.38654 0.143904 9.19552 0 8.95987 0Z"
                      fill="#767B82"
                    />
                    <path
                      d="M5.04065 2.95978L3.88083 1.79479C3.77406 1.68754 3.60093 1.68754 3.49414 1.79479C3.38737 1.90203 3.38737 2.07593 3.49414 2.1832L4.65396 3.3482C4.76073 3.45544 4.93388 3.45547 5.04065 3.3482C5.14742 3.24095 5.14742 3.06706 5.04065 2.95978Z"
                      fill="#767B82"
                    />
                    <path
                      d="M13.5739 1.79479C13.4671 1.68754 13.294 1.68754 13.1872 1.79479L12.0273 2.95978C11.9206 3.06703 11.9206 3.24093 12.0273 3.3482C12.1341 3.45544 12.3072 3.45547 12.414 3.3482L13.5739 2.1832C13.6806 2.07596 13.6806 1.90206 13.5739 1.79479Z"
                      fill="#767B82"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.53333 3.42871C11.7215 3.42871 14.8657 5.39984 16.9832 7.7708C17.105 7.90725 17.092 8.1156 16.954 8.23613C16.8156 8.35702 16.605 8.3433 16.4835 8.20728C16.4125 8.12777 16.3397 8.04851 16.266 7.96972C14.6188 10.4312 11.6329 12.0001 8.53333 12.0001C5.43377 12.0001 2.44783 10.4312 0.800664 7.96972C0.726964 8.04848 0.654197 8.12773 0.583164 8.20728C0.461331 8.34373 0.250664 8.35666 0.112664 8.23613C-0.025303 8.1156 -0.0383696 7.90728 0.0834971 7.7708C2.2006 5.40034 5.3447 3.42871 8.53333 3.42871ZM1.27703 7.48432C2.7843 9.8349 5.60283 11.3408 8.53333 11.3408C11.4638 11.3408 14.2824 9.8349 15.7896 7.48428C14.602 6.3334 11.858 4.08805 8.53333 4.08805C5.2087 4.08805 2.46463 6.3334 1.27703 7.48432Z"
                      fill="#767B82"
                    />
                  </svg>

                  <svg
                    class="hide__pass"
                    width="18"
                    height="7"
                    viewBox="0 0 18 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.9491 2.46709L16.9331 2.46211C16.4245 2.30303 15.9868 1.98437 15.6781 1.55386C15.9951 1.29643 16.3007 1.02103 16.5926 0.726816C16.7576 0.560547 16.7576 0.290982 16.5926 0.12467C16.4277 -0.0415567 16.1602 -0.0415567 15.9952 0.12467C14.3384 1.79447 12.2221 2.83279 9.93366 3.12016C9.91832 3.12122 9.9032 3.12301 9.88833 3.12565C9.47197 3.1761 9.05008 3.20195 8.62421 3.20199C8.624 3.20199 8.62379 3.20195 8.62354 3.20195C8.62328 3.20195 8.62311 3.20199 8.62286 3.20199C8.197 3.20199 7.7751 3.1761 7.3587 3.12565C7.34383 3.12297 7.32875 3.12118 7.31337 3.12016C5.02495 2.83279 2.90864 1.79447 1.25183 0.12467C1.08685 -0.0415141 0.819371 -0.0415567 0.654391 0.12467C0.489411 0.290939 0.489411 0.560504 0.654391 0.726816C0.946328 1.02103 1.25195 1.29647 1.56894 1.55386C1.26028 1.98437 0.822624 2.30307 0.314461 2.46193L0.297899 2.46709C0.0749547 2.53649 -0.0499315 2.77484 0.0189334 2.99953C0.0749547 3.18236 0.242047 3.29975 0.422405 3.29975C0.463724 3.29975 0.505719 3.29358 0.547207 3.28068L0.564318 3.27536C1.24485 3.06251 1.83101 2.63719 2.24606 2.06285C2.39055 2.1632 2.53702 2.26003 2.68552 2.35315C2.47923 3.00554 1.99637 3.5327 1.35593 3.78877L1.22512 3.84101C1.00822 3.9277 0.902178 4.17517 0.988154 4.39372C1.05389 4.56084 1.21283 4.66261 1.38094 4.66261C1.43278 4.66261 1.48546 4.6529 1.53658 4.6325L1.66751 4.58018C2.48928 4.2516 3.12263 3.59772 3.43218 2.78196C3.59446 2.86703 3.75859 2.94797 3.92459 3.02478C3.87617 3.75488 3.45732 4.40658 2.80707 4.74849L2.78189 4.76173C2.575 4.87043 2.49473 5.12757 2.60255 5.33607C2.67788 5.48173 2.82507 5.5651 2.97746 5.5651C3.04324 5.5651 3.11004 5.54956 3.1724 5.51678L3.1977 5.50349C4.02729 5.06727 4.58843 4.27216 4.7355 3.36175C4.91468 3.42796 5.0955 3.4897 5.27806 3.54662C5.25389 4.22196 4.99406 4.86383 4.53917 5.36396C4.3815 5.5373 4.39312 5.80657 4.56516 5.96551C4.64627 6.04045 4.74851 6.07741 4.85046 6.07741C4.96478 6.07741 5.07873 6.03091 5.162 5.93933C5.70945 5.33739 6.03975 4.57749 6.1106 3.7714C6.3534 3.82683 6.59866 3.8738 6.84589 3.91301C6.79114 4.56706 6.59198 5.2031 6.26067 5.77135L6.2038 5.8689C6.08563 6.07166 6.15293 6.33254 6.35412 6.45167C6.42134 6.49144 6.49498 6.51039 6.56773 6.51039C6.71264 6.51039 6.85367 6.43515 6.93238 6.30014L6.9892 6.20267C7.37966 5.533 7.61642 4.78438 7.68528 4.01405C7.85647 4.02819 8.02842 4.03836 8.20105 4.04475V6.57426C8.20105 6.80938 8.3902 7 8.62349 7C8.85679 7 9.04594 6.80933 9.04594 6.57426V4.04475C9.2186 4.03836 9.39051 4.02819 9.5617 4.01405C9.63057 4.7843 9.86729 5.533 10.2577 6.20259L10.3146 6.30014C10.3933 6.4352 10.5344 6.51039 10.6793 6.51039C10.752 6.51039 10.8256 6.49144 10.8929 6.45167C11.0941 6.33254 11.1613 6.07166 11.0432 5.8689L10.9863 5.77127C10.655 5.2031 10.4558 4.56698 10.4011 3.91301C10.6483 3.87375 10.8936 3.82683 11.1364 3.7714C11.2072 4.57745 11.5375 5.33739 12.085 5.93933C12.1683 6.03091 12.2822 6.07741 12.3965 6.07741C12.4985 6.07741 12.6008 6.04041 12.6818 5.96551C12.8538 5.80661 12.8655 5.5373 12.7078 5.36396C12.253 4.86383 11.9931 4.22188 11.9689 3.54662C12.1515 3.4897 12.3323 3.428 12.5115 3.36175C12.6586 4.2722 13.2197 5.06732 14.0494 5.50353L14.0746 5.51678C14.137 5.54956 14.2037 5.5651 14.2695 5.5651C14.422 5.5651 14.5691 5.48169 14.6444 5.33607C14.7523 5.12757 14.672 4.87039 14.4651 4.76173L14.44 4.74853C13.7897 4.40663 13.3708 3.75488 13.3224 3.02478C13.4884 2.94797 13.6526 2.86703 13.8148 2.78196C14.1243 3.59772 14.7577 4.2516 15.5795 4.58022L15.7104 4.63255C15.7615 4.65294 15.8142 4.66265 15.8661 4.66265C16.0342 4.66265 16.1931 4.56076 16.2588 4.39377C16.3449 4.17517 16.2388 3.92774 16.0219 3.84105L15.8911 3.78877C15.2506 3.53266 14.7677 3.00549 14.5614 2.3531C14.7099 2.25998 14.8564 2.16316 15.0009 2.0628C15.4159 2.63719 16.0021 3.06251 16.6832 3.27548L16.6997 3.28064C16.7413 3.29358 16.7833 3.29971 16.8245 3.29971C17.0049 3.29971 17.172 3.18228 17.228 2.99949C17.297 2.77484 17.1721 2.53649 16.9491 2.46709Z"
                      fill="#767B82"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <p class="txt--ss txt--semi-bold txt--red mb-3">
              Password must contain minimum 8 characters including at least one
              number,one uppercase,one lowercase,one special character
            </p>
          </div>
        </div>

        <div class="d-flex justify-content-center flex-wrap mt-4">
          <button
            type="button"
            class="button button--primary button--sm mr-3"
            @click="changePassword()"
          >
            Save
          </button>
          <button
            type="button"
            class="button button--outline button--sm"
            @click="viewScreen = 'profile'"
          >
            Cancel
          </button>
        </div>
      </div>
      <!-- Add & Update Bank Information -->
      <div v-if="viewScreen == 'bankDetails'">
        <div class="content__box">
          <div class="content__box__body">
            <p class="txt--ss txt--semi-bold txt--off-white mb-3">
              Update Bank Account
            </p>

            <div class="form__group mb-3">
              <label class="txt--xs txt--off-white">Name</label>
              <input
                type="text"
                class="textInputField"
                placeholder="Enter account name"
                v-model="account_holder"
              />
            </div>
            <div class="form__group mb-3">
              <label class="txt--xs txt--off-white">Account Number</label>
              <input
                type="text"
                class="textInputField"
                placeholder="Enter account number"
                v-model="account_number"
              />
            </div>
            <div class="form__group mb-3">
              <label class="txt--xs txt--off-white">Routing Number</label>
              <input
                type="text"
                class="textInputField"
                placeholder="Enter routing number"
                v-model="routing_number"
              />
            </div>
          </div>
        </div>
        
        <div class="d-flex justify-content-center flex-wrap mt-4">
          <button
            type="button"
            class="button button--primary button--sm mr-3"
            @click="updateAccountData()"
            :disabled="account_update_disabled"
          >
            Save
          </button>
          <button
            type="button"
            class="button button--outline button--sm"
            @click="viewScreen = 'profile'"
          >
            Cancel
          </button>
        </div>
      </div>
      <!-- Add & Update Payment Statement Descriptor -->
      <div v-if="viewScreen == 'statementDescriptor'">
        <div class="content__box">
          <div class="content__box__body">
            <p class="txt--ss txt--semi-bold txt--off-white mb-3">
              Add/Update Payment Statement Descriptor
            </p>

            <div class="form__group mb-3">
              <label class="txt--xs txt--off-white">Payment Statement</label>
              <input
                type="text"
                class="textInputField"
                placeholder="Enter payment statement descriptor"
                v-model.trim="temp_payment_statement_descriptor"
              />
            </div>
          </div>
        </div>
        
        <div class="d-flex justify-content-center flex-wrap mt-4">
          <button
            type="button"
            class="button button--primary button--sm mr-3"
            @click="addUpdatePaymentStatementDescriptor"
            :disabled="statement_descriptor_submit"
          >
            Save
          </button>
          <button
            type="button"
            class="button button--outline button--sm"
            @click="clearInput"
          >
            Cancel
          </button>
        </div>
      </div>
      <!-- Switch Account -->
      <div class="available-accounts mt-4" v-if="operator_account_list.length>0">
        <p class="txt--off-white mb-3 txt--s font-weight-bold">
          Switch Account
        </p>
        <div class="account account__switching__spin" v-for="(account, index) in operator_account_list" :key="index">
          <div class="profile__image mr-3" v-if="account.square_company_logo!='' || account.profile_image!=''">
            <img
              :src="account.square_company_logo!='' ? account.square_company_logo : account.profile_image"
              alt="Account Name"
              class="w-100 h-100"
              title="Account Name"
            />
          </div>
          <div class="profile__image mr-3" v-else>
            <img src="@/assets/images/header_default_logo.png" alt="Account Name" class="w-100 h-100" title="Account Name">
          </div>
          <div class="account__details">
            <p class="font-weight-bold txt--off-white mb-1">{{account.company}}</p>
            <p class="txt--s txt--ss txt--off-white">{{account.email}}</p>
          </div>
          <div class="account__switching__spinner">
            <span v-if="user.company_id == account.company_id" class="txt--primary txt--ss">Selected</span>
            <span class="spinner" v-else-if="changing_account==account.company_id"></span>
            <span v-else-if="user.company_id != account.company_id && changing_account==''" class="txt--primary txt--ss" @click="switchAccount(account.company_id)">Switch</span>
          </div>
        </div>
      </div>
      <!-- Close Button -->
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
import ButtonWithSpinner from "@/components/Button";
export default {
  props: ["user"],
  components: {
    ButtonWithSpinner
  },
  data() {
    return {
      disabled: false,
      viewScreen: "profile",
      phone: null,
      phone_number: null,
      is_phone_valid: true,
      country_code: null,
      phone_input_options: { showDialCode: true, tabindex: 0 },
      first_name: "",
      last_name: "",
      company: "",
      email: "",
      role: "",
      //======= Password section ===//
      old_password: "",
      new_password: "",
      confirm_password: "",
      //======= Account section ====//
      account_data: {},
      account_list: [],
      account_holder: "",
      routing_number: "",
      account_number: "",
      account_id: "",
      external_account_id: '',
      stripe_verified: "unverified",
      verification_url: null,
      account_update_disabled: false,
      statement_descriptor_submit: false,
      temp_payment_statement_descriptor: '',
      payment_statement_descriptor:'',
      generating_stripe_login_link: false,
      stripe_login_link: '',
      button: {
        loading: false,
        disabled: false,
        success: false,
      },
      //========= Switch Account Section ======//
      operator_account_list: [],
      changing_account: '',
    };
  },
  computed: {
    computeModalWidth() {
      if (this.$mq === "lg") return "900px";
      else return "400px";
    },
  },
  created() {
    this.country_code = this.user.country_code ? this.user.country_code : null;
    this.phone = this.user.country_code ? "+" + this.user.country_code : "";
    this.phone_number = this.user.phone_number;
    this.phone = this.user.phone_number
      ? this.phone + this.user.phone_number
      : this.phone;
    this.first_name = this.user.first_name;
    this.last_name = this.user.last_name;
    this.email = this.user.email;
    this.company = this.user.company;
    this.stripe_verified = this.user.external_account_verification_status;
    this.disabled = this.user.role == "operator" ? true : false;
    this.role = this.user.role;
    this.operator_account_list = this.user.operator_account_list;
    this.payment_statement_descriptor = this.user.payment_statement_descriptor?this.user.payment_statement_descriptor:'';
    this.temp_payment_statement_descriptor = this.user.payment_statement_descriptor?this.user.payment_statement_descriptor:'';
    this.external_account_id = this.user.external_account_id;
  },
  mounted() {
    this.getAccountDetails();
  },
  methods: {
    togglePassword(e) {
      const PASSWORD_TOGGLE_BUTTON = e.currentTarget;
      const PASSWORD_FIELD_WRAPPER = PASSWORD_TOGGLE_BUTTON.parentElement;
      const PASSWORD_FIELD = PASSWORD_FIELD_WRAPPER.querySelector("input");
      const PASSWORD_VISIBLE_STATUS = PASSWORD_TOGGLE_BUTTON.dataset.password;

      if (PASSWORD_VISIBLE_STATUS === "hidden") {
        PASSWORD_TOGGLE_BUTTON.setAttribute("data-password", "show");
        PASSWORD_FIELD.setAttribute("type", "text");
      } else {
        PASSWORD_TOGGLE_BUTTON.setAttribute("data-password", "hidden");
        PASSWORD_FIELD.setAttribute("type", "password");
      }
    },
    closeModal() {
      this.$modal.hide("account-settings");
      this.$emit("Profile_updated");
    },
    checkPhoneValidity(event) {
      if (!event.isValid) {
        this.is_phone_valid = false;
        this.phone_number = false;
      } else {
        this.is_phone_valid = true;

        this.phone_number = event.number.significant;
      }
    },
    getCountryCode(event) {
      this.country_code = event.dialCode;
    },
    formatUSPhone() {
      if (this.phone.indexOf("+1") != -1) {
        this.phone = this.phone.split("+1")[1];
      }
      let numbers = this.phone.replace(/\D/g, ""),
        char = {
          0: "(",
          3: ") ",
          6: " - ",
        };
      let phone = "";
      for (var i = 0; i < numbers.length; i++) {
        phone += (char[i] || "") + numbers[i];
      }
      this.phone = "+1" + phone;
    },
    deformatPhone(formatted_phone) {
      if (formatted_phone.indexOf("+1") != -1) {
        formatted_phone = formatted_phone.split("+1")[1];
      }
      let phone = formatted_phone.replace("(", "");
      phone = phone.replace(")", "");
      phone = phone.replace("-", "");
      phone = phone.replace(/\s/g, "");
      return phone;
    },
    getImage(event) {
      this.formData = new FormData();
      // this.formData.append("device_type", 1);
      // this.formData.append("mode", "image-update");
      let image = event.target.files[0];

      if (
        image.type.split("/")[1] != "jpeg" &&
        image.type.split("/")[1] != "jpg" &&
        image.type.split("/")[1] != "png"
      ) {
        this.$toasted.show("Please upload a valid Image file", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (image.size > 2097152) {
        this.$toasted.show("Please upload an image file below 2MB!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      this.formData.append("square_image", image);
      this.axios
        .post(window.hostname + "api/auth/uplod-square-image", this.formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res.data.status) {
            // this.user.square_image = res.data.data.profile_image;
            this.$toasted.show("Profile Image updated successfully!", {
              icon: "check-circle",
              className: "success-class",
            });
            this.$emit("Profile_updated");
          } else {
            this.$toasted.show("Profile Image could not be updated!", {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch((error) => {
          this.$toasted.show(error.response.data.message, {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
    updateUserDetails() {
      if (this.first_name == "") {
        this.$toasted.show("First Name can not be empty", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (this.last_name == "") {
        this.$toasted.show("Last Name can not be empty", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (this.email == "") {
        this.$toasted.show("Email can not be empty", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      if (!this.is_phone_valid) {
        this.$toasted.show("Please provide a valid phone number!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }
      if (this.company == "") {
        this.$toasted.show("Company Name can not be empty!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      this.axios
        .post(window.hostname + "/api/auth/users", {
          device_type: 1,
          mode: "update",
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          dob: this.user.dob,
          country_code: this.country_code,
          company: this.company,
          phone_number: this.phone_number,
        })
        .then((res) => {
          if (res.data.status) {
            this.$toasted.show("Profile updated successfully!", {
              icon: "check-circle",
              className: "success-class",
            });
          } else {
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch((error) => {
          this.$toasted.show(error.response.data.message, {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
    changePassword() {
      if (this.old_password == "") {
        this.$toasted.show("Please enter your old password !", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      } else if (this.new_password == "") {
        this.$toasted.show("Please enter a new password !", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      } else if (this.new_password.length < 8) {
        this.$toasted.show("New Password must have atleast 8 characters!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      } else if (/\d/.test(this.new_password) == false) {
        this.$toasted.show("New Password must have one number!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      } else if (/[a-z]/.test(this.new_password) == false) {
        this.$toasted.show("New Password must have one lower case letter!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      } else if (/[A-Z]/.test(this.new_password) == false) {
        this.$toasted.show("New Password must have one upper case letter!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      } else if (window.regularExpressions.specialChars.test(this.new_password) == false) {
        this.$toasted.show("New Password must have one special charecter!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      } else if (!this.confirm_password) {
        this.$toasted.show("Confirm password is required !", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      } else if (this.confirm_password.length < 8) {
        this.$toasted.show("Confirm password must have atleast 8 characters!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      } else {
        this.axios
          .post(window.hostname + "/api/auth/users", {
            device_type: 1,
            mode: "change-password",
            old_password: this.old_password,
            new_password: this.new_password,
            confirm_password: this.confirm_password,
          })
          .then((res) => {
            if (res.data.status) {
              this.new_password = "";
              this.old_password = "";
              this.confirm_password = "";
              this.$toasted.show("Password changed successfully!", {
                icon: "check-circle",
                className: "success-class",
              });
              this.viewScreen = "profile";
            } else {
              this.$toasted.show(res.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            }
          })
          .catch((error) => {
            this.$toasted.show(error.response.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          });
      }
    },
    getAccountDetails() {
      this.axios
        .post(window.hostname + "api/auth/account-management", {
          device_type: 1,
          mode: "account-list",
        })
        .then((res) => {
          if (res.data.status) {
            this.account_list = res.data.data.bank_account_list;
            this.account_list.map((val) => {
              if (val.default == 1) {
                this.account_data = val;
              }
            });
            this.account_id = this.account_data.account_id;
            this.account_holder =
              this.account_data.bank_details.account_holder_name;
            this.routing_number = this.account_data.bank_details.routing_number;
            this.external_account_id = res.data.data.bank_account_list[0].connected_account_id;
            if (this.stripe_verified != "verified") {
              this.getAccountVerificationLink();
            }
          } else {
            this.account_data = {};
            this.account_list = [];
            this.account_holder = "";
            this.routing_number = "";
            this.account_id = "";

            if(this.user.external_account_type == 'STANDARD' && this.external_account_id!='') {
              this.getAccountVerificationLink();
            }
          }
        })
        .catch(err=> {
          console.log(err);
        });
    },
    updateAccountData() {
      if (this.account_holder == "") {
        this.$toasted.show("Account holder name is required", {
          icon: "times-circle",
          className: "error-class",
        });
        return false;
      }
      if (this.account_number == "") {
        this.$toasted.show("Account number is required", {
          icon: "times-circle",
          className: "error-class",
        });
        return false;
      }
      if (this.routing_number == "") {
        this.$toasted.show("Routing number is required", {
          icon: "times-circle",
          className: "error-class",
        });
        return false;
      }

      let requestObject = {
        mode: "add-account",
        device_type: 1,
        routing_number: this.routing_number,
        account_number: this.account_number,
        account_holder: this.account_holder,
        account_type: "company",
      };

      if (this.account_id != "") {
        requestObject.account_id = this.account_id;
        requestObject.mode = "update-account";
      }

      this.account_update_disabled = true;

      this.axios
        .post(window.hostname + "/api/auth/account-management", requestObject)
        .then((res) => {
          if (res.data.status) {
            this.account_holder = "";
            this.account_number = "";
            this.routing_number = "";
            this.getAccountDetails();
            this.$toasted.success(res.data.message, {
              icon: "check-circle",
              className: "success-class",
            });
            this.viewScreen = "profile";
          } else {
            this.$toasted.error(
              "Account details is invalid. Please provide a valid account details!",
              {
                icon: "times-circle",
                className: "error-class",
              }
            );
          }
          this.account_update_disabled = false;
        })
        .catch((error) => {
          this.account_update_disabled = false;
          console.log(error.response.data.message);
          this.$toasted.error(
            "Account details is invalid. Please provide a valid account details!",
            {
              icon: "times-circle",
              className: "error-class",
            }
          );
        });

    },
    getAccountVerificationLink() {
      this.axios
        .post(window.hostname + "/api/auth/account-management", {
          mode: "verify-external-account-link",
          success_url: window.location.href,
          error_url: window.location.href,
        })
        .then((res) => {
          this.verification_url = "";
          if (res.data.status) {
            if (res.data.data.verification_status == "verified") {
              this.stripe_verified = "verified";
              this.verification_url = "";
            } else {
              this.stripe_verified = res.data.data.verification_status;
              this.verification_url = res.data.data.verification_url;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getOTP() {
      const self = this;
      //============ Send OTP In Mail =============//
      this.axios
        .post(window.hostname + "/api/auth/users", {
          mode: "change-email",
          step: "get-otp",
          device_type: 1,
        })
        .then((res) => {
          if (res.data.status) {
            this.$toasted.show(
              "An OTP has been sent to your Registered Email!",
              {
                icon: "check-circle",
                className: "success-class",
              }
            );
          } else {
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toasted.show("Something went wrong. Please try again!", {
            icon: "times-circle",
            className: "error-class",
          });
        });

      //================= Open OTP Submit Modal ==============//
      await this.$swal({
        title: "Enter OTP",
        html: `<div class="row">
            <div class="col-md-12">
              <div class="d-flex align-items-center">
                <p class="txt--xs txt--off-white">An OTP has been sent to your registered Email Id. Please insert the OTP to change your Email.</p>
              </div>
            </div>
            <div class="col-md-12">
              <div class="d-flex align-items-center">
                <p class="txt--xs txt--off-white">OTP:</p>
                <input type="number" placeholder="Enter OTP" class="hidden_input hidden_input__lg w-100" min="0" max="23" id="swal-otp" value="">
              </div>
            </div>
          </div>`,
        showCancelButton: true,
        preConfirm: () => {
          var otp = document.getElementById("swal-otp").value;
          if (otp == "") {
            self.$toasted.show("Please insert an OTP", {
              icon: "times-circle",
              className: "error-class",
            });
            return false;
          }
          //================== Verify OTP =================//
          return self.axios
            .post(window.hostname + "/api/auth/users", {
              mode: "change-email",
              step: "verify-otp",
              otp: otp,
              device_type: 1,
            })
            .then((res) => {
              if (res.data.status) {
                return 1;
              } else {
                self.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                return false;
              }
            })
            .catch((err) => {
              console.log(err);
              self.$toasted.show("Something went wrong. Please try again!", {
                icon: "times-circle",
                className: "error-class",
              });
              return false;
            });
        },
      }).then((result) => {
        if (result.isDismissed) {
          return false;
        }
        if (result) {
          self
            .$swal({
              title: "Change Email",
              html: `<div class="row">
              <div class="col-md-12">
                <div class="d-flex align-items-center">
                  <p class="txt--xs txt--off-white">Email:</p>
                  <input type="email" placeholder="Enter Email" class="hidden_input hidden_input__lg w-100" id="swal-email" value="">
                </div>
              </div>
            </div>`,
              showCancelButton: true,
              preConfirm: () => {
                var email = document.getElementById("swal-email").value;
                if (email == "") {
                  self.$toasted.show("Email is required!", {
                    icon: "times-circle",
                    className: "error-class",
                  });
                  return false;
                }
                //================ SEND EMAIL FOR UNIQUE CHECKING AND UPDATE ===========//
                return self.axios
                  .post(window.hostname + "/api/auth/users", {
                    mode: "change-email",
                    step: "email-change",
                    email: email,
                    device_type: 1,
                  })
                  .then((res) => {
                    if (res.data.status) {
                      //================ IF EMail Updated Successfully ================//
                      return email;
                    } else {
                      self.$toasted.show(res.data.message, {
                        icon: "times-circle",
                        className: "error-class",
                      });
                      return false;
                    }
                  })
                  .catch((err) => {
                    self.$toasted.show(err.response.data.message, {
                      icon: "times-circle",
                      className: "error-class",
                    });
                    return false;
                  });
              },
            })
            .then((result) => {
              if (result.isDismissed) {
                return false;
              }
              if (result) {
                self.$toasted.show("Email changed successfully!", {
                  icon: "check-circle",
                  className: "success-class",
                });
                self.email = result.value;
              }
            });
        }
      });
    },
    async switchAccount(account_id) {
      const self = this;
      this.changing_account = account_id;
      await this.$swal({
        title: "Confirm your password",
        html: `<div class="row">
            <div class="col-md-12">
              <div class="d-flex align-items-center">
                <p class="txt--off-white txt--ss mb-2">Enter Your Password</p>
              </div>
            </div>
            <div class="col-md-12">
              <div class="d-flex align-items-center">
                <input type="password" placeholder="Enter password" class="textInputField" id="swal-password" value="">
              </div>
            </div>
          </div>`,
        showCancelButton: true,
        preConfirm: () => {
          var password = document.getElementById("swal-password").value;
          if (password == "") {
            self.$toasted.show("Please provide a password!", {
              icon: "times-circle",
              className: "error-class",
            });
            self.changing_account = '';
            return false;
          }

          return self.axios.post(window.hostname+'api/auth/operator/switch-account',{
            company_id: account_id,
            password: password
          })
          .then(res=> {
            if(res.data.status) {
              localStorage.setItem("commercial_token_new", res.data.access_token);
              localStorage.setItem("loader",res.data.user.loader);
              //store the operators access list
              localStorage.setItem("role", res.data.user.role);
              if (res.data.user.role == 'operator') {
                localStorage.setItem("commercial_access_list", JSON.stringify(res.data.user.access));
              }
              self.changing_account = '';
              return true;
            }
            else {
              password = '';
              self.$toasted.show("Please provide valid credentials!",{
                icon: 'times-circle',
                className: 'error-class'
              });
              self.changing_account = '';
              return false;
            }
          })
          .catch(err=> {
            self.$toasted.show("Please provide valid credentials!",{
              icon: 'times-circle',
              className: 'error-class'
            });
            self.changing_account = '';
            return false;
          });
        }
      })
      .then((result) => {
        if (result.isDismissed) {
          self.changing_account = '';
          return false;
        }
        if (result) {
          self.changing_account = '';
          self.$router.push({name : 'Welcome'});
        }
      })
    },
    clearInput() {
      this.viewScreen = 'profile';
      this.temp_payment_statement_descriptor = JSON.parse(JSON.stringify(this.payment_statement_descriptor));
    },
    addUpdatePaymentStatementDescriptor() {
      if(this.temp_payment_statement_descriptor.trim().length == 0) {
        this.$toasted.show("Payment statement descriptor can not be empty!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      if(this.temp_payment_statement_descriptor.length > 20) {
        this.$toasted.error("Payment statement descriptor is not valid!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      let requestObjectNew = {
        device_type: 1,
        payment_statement_descriptor: this.temp_payment_statement_descriptor,
      };

       this.statement_descriptor_submit = true;

       this.axios
        .post(window.hostname + "/api/auth/statement-descriptor", requestObjectNew)
        .then((res) => {
          if (res.data.status) {
            this.$toasted.success(res.data.message, {
              icon: "check-circle",
              className: "success-class",
            });
            this.payment_statement_descriptor = JSON.parse(JSON.stringify(this.temp_payment_statement_descriptor));
            this.viewScreen = "profile";
          } else {
            this.$toasted.error(res.data.message,{
              icon: "times-circle",
              className: "error-class",
            });
          }
          this.statement_descriptor_submit = false;
        })
        .catch((error) => {
          this.statement_descriptor_submit = false;
          console.log(error.response.data.message);
          this.$toasted.error("Payment Statement Descriptor could not be saved. Please try again later!", {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
    generateStripeLoginLink() {
      this.generating_stripe_login_link= true;
      this.axios.post(window.hostname+'api/auth/account-login-link')
      .then(res=> {
        if(res.data.status) {
          this.stripe_login_link = res.data.data;
        }
        else {
          this.$toasted.show(res.data.message,{
            icon: 'times-circle',
            className: 'error-class'
          });
        }
        this.generating_stripe_login_link = false;
      })
      .catch(err=> {
        this.$toasted.show("Stripe Login link can not be created. Please try again later!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        this.generating_stripe_login_link = false;
      });
    },
    createStandardAccount() {
      this.button.disabled= true;
      this.button.loading = true;

      this.axios.post(window.hostname+'api/auth/account-management',{
        device_type: 1,
        mode: 'add-standard-account'
      })
      .then(res=> {
        if(res.data.status) {
          this.$toasted.show(res.data.message,{
            icon: 'check-circle',
            className: 'success-class'
          });
          this.external_account_id = res.data.account_id;
          this.getAccountVerificationLink();
        }
        else {
          this.$toasted.show(res.data.message,{
            icon: 'times-circle',
            className: 'error-class'
          });
        }
        this.button.loading = false;
        this.button.disabled = false;
      })
      .catch(err=> {
        this.button.loading = false;
        this.button.disabled = false;
      })
    }
  }
}
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}
/* .profile_image{
  border-radius : 50%;
  height : 55px;
} */
.vti__dropdown-list {
  color: var(--primaryColor) !important;
  background-color: var(--lightDark) !important;
  font-size: 10px;
}
.vti__dropdown {
  padding: 3px !important;
}
.vue-tel-input {
  border: 0px !important ;
}

.vti__dropdown {
  scrollbar-width: thin;
  scrollbar-color: var(--primaryColor) var(--lightDark);
}

/* Works on Chrome/Edge/Safari */
.vti__dropdown ::-webkit-scrollbar {
  width: 12px;
}
.vti__dropdown ::-webkit-scrollbar-track {
  background: var(--lightDark);
}
.vti__dropdown ::-webkit-scrollbar-thumb {
  background-color: var(--primaryColor);
  border-radius: 20px;
  border: 3px solid var(--lightDark);
}
</style>
